import { MESES_PT_BR, adicionarMeses } from "../../../shared/lib/date";

// O mês dos filtros de Recebíveis e da Visão Geral é o mês em que o pagamento cai (issue
// #18). Como o pagamento chega sempre no mês seguinte ao serviço, a legenda deixa claro
// que outubro soma os plantões de setembro. O ano do mês de serviço só aparece quando
// difere (virada de ano), para a frase não repetir o mesmo ano duas vezes.
export function describePaymentMonth({ ano, mes }) {
  const servico = adicionarMeses(ano, mes, -1);
  const nomeServico = MESES_PT_BR[servico.mes - 1].toLowerCase();
  const rotuloServico = servico.ano === ano ? nomeServico : `${nomeServico} de ${servico.ano}`;
  return `Plantões de ${rotuloServico}, pagos em ${MESES_PT_BR[mes - 1].toLowerCase()} de ${ano}`;
}
